import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer:DomSanitizer){}

  transform(html: string): any {

    if(!html) return 'no encontré nada';
    return this.sanitizer.bypassSecurityTrustHtml(html) || html;
  }

}
